import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const InfoDeskModal = ({ onClose }) => {
  const helpTopics = [
    {
      id: 1,
      title: 'How to Navigate the Fair',
      icon: 'Map',
      description: 'Learn how to explore different zones and visit institute booths'
    },
    {
      id: 2,
      title: 'Booking Video Sessions',
      icon: 'Video',
      description: 'Schedule one-on-one counseling sessions with university representatives'
    },
    {
      id: 3,
      title: 'Chatting with Institutes',
      icon: 'MessageSquare',
      description: 'Start conversations and get your questions answered in real-time'
    },
    {
      id: 4,
      title: 'Saving Favorites',
      icon: 'Heart',
      description: 'Bookmark institutes and courses you\'re interested in'
    },
    {
      id: 5,
      title: 'Downloading Resources',
      icon: 'Download',
      description: 'Access brochures, prospectuses, and application forms'
    },
    {
      id: 6,
      title: 'Technical Support',
      icon: 'HelpCircle',
      description: 'Get help with technical issues or platform questions'
    }
  ];

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e?.stopPropagation()}>
        <div className="sticky top-0 bg-gradient-to-r from-red-600 to-red-700 text-white p-6 rounded-t-2xl">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
                <Icon name="Info" size={28} color="white" />
              </div>
              <div>
                <h2 className="text-2xl font-heading font-bold">Information Desk</h2>
                <p className="text-white/90 text-sm">How can we help you today?</p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="w-10 h-10 bg-white/20 hover:bg-white/30 rounded-lg flex items-center justify-center transition-colors"
            >
              <Icon name="X" size={24} color="white" />
            </button>
          </div>
        </div>

        <div className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
            {helpTopics?.map((topic) => (
              <div
                key={topic?.id}
                className="p-4 border-2 border-border rounded-xl hover:border-primary hover:bg-primary/5 transition-all cursor-pointer group"
              >
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 bg-primary/10 group-hover:bg-primary/20 rounded-lg flex items-center justify-center flex-shrink-0 transition-colors">
                    <Icon name={topic?.icon} size={20} color="var(--color-primary)" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-foreground mb-1 group-hover:text-primary transition-colors">
                      {topic?.title}
                    </h3>
                    <p className="text-sm text-muted-foreground">{topic?.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="bg-slate-50 rounded-xl p-6 mb-6">
            <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
              <Icon name="Clock" size={20} color="var(--color-primary)" />
              Fair Timings
            </h3>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between">
                <span className="text-muted-foreground">Monday - Friday:</span>
                <span className="font-semibold text-foreground">9:00 AM - 6:00 PM</span>
              </div>
              <div className="flex justify-between">
                <span className="text-muted-foreground">Saturday:</span>
                <span className="font-semibold text-foreground">10:00 AM - 4:00 PM</span>
              </div>
              <div className="flex justify-between">
                <span className="text-muted-foreground">Sunday:</span>
                <span className="font-semibold text-foreground">Closed</span>
              </div>
            </div>
          </div>

          <div className="bg-primary/5 border-2 border-primary/20 rounded-xl p-6">
            <h3 className="text-lg font-semibold text-foreground mb-3 flex items-center gap-2">
              <Icon name="Headphones" size={20} color="var(--color-primary)" />
              Need Live Support?
            </h3>
            <p className="text-sm text-muted-foreground mb-4">
              Our support team is available to assist you with any questions or technical issues.
            </p>
            <div className="flex gap-3">
              <Button variant="default" iconName="MessageSquare" iconPosition="left">
                Start Live Chat
              </Button>
              <Button variant="outline" iconName="Mail" iconPosition="left">
                Email Support
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoDeskModal;